import * as React from 'react'
import {
  Select,
  SelectGroup,
  SelectValue,
  SelectContent,
  SelectLabel,
  SelectSeparator,
  SelectScrollUpButton,
  SelectScrollDownButton,
  SelectTrigger as ShadcnSelectTrigger,
  SelectItem as ShadcnSelectItem,
} from '@/components/ui/shadcn/select'
import { cn } from '@/lib/utils'

// Thin wrappers so every Select trigger/item gets cursor-pointer (project rule:
// clickable elements always show the pointer). The raw shadcn trigger has no
// cursor and items are cursor-default.
const SelectTrigger = React.forwardRef<
  React.ElementRef<typeof ShadcnSelectTrigger>,
  React.ComponentPropsWithoutRef<typeof ShadcnSelectTrigger>
>(({ className, ...props }, ref) => (
  <ShadcnSelectTrigger ref={ref} className={cn('cursor-pointer', className)} {...props} />
))
SelectTrigger.displayName = 'SelectTrigger'

const SelectItem = React.forwardRef<
  React.ElementRef<typeof ShadcnSelectItem>,
  React.ComponentPropsWithoutRef<typeof ShadcnSelectItem>
>(({ className, ...props }, ref) => (
  <ShadcnSelectItem ref={ref} className={cn('cursor-pointer', className)} {...props} />
))
SelectItem.displayName = 'SelectItem'

export {
  Select,
  SelectGroup,
  SelectValue,
  SelectTrigger,
  SelectContent,
  SelectLabel,
  SelectItem,
  SelectSeparator,
  SelectScrollUpButton,
  SelectScrollDownButton,
}
